"use client";

import { c as _c } from "react/compiler-runtime";
import { getActiveWaveIdFromUrl, getWaveHomeRoute, getWaveRoute } from "@/helpers/navigation.helpers";
import { useClientNavigation } from "@/hooks/useClientNavigation";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { usePathname, useSearchParams } from "next/navigation";
import { useCallback, useMemo } from "react";
interface WaveNavigationOptions {
  isDirectMessage?: boolean | undefined;
  serialNo?: number | string | null | undefined;
  divider?: number | null | undefined;
}
const getWaveFromWindow = (): string | null => {
  if (globalThis.window === undefined) return null;
  const url = new URL(globalThis.window.location.href);
  return getActiveWaveIdFromUrl({
    pathname: url.pathname,
    searchParams: url.searchParams
  });
};
const getRouteContext = (): {
  isOnWaves: boolean;
  isOnMessages: boolean;
} => {
  if (globalThis.window === undefined) {
    return {
      isOnWaves: false,
      isOnMessages: false
    };
  }
  const pathname = globalThis.window.location.pathname;
  return {
    isOnWaves: pathname === "/waves" || pathname.startsWith("/waves/"),
    isOnMessages: pathname === "/messages" || pathname.startsWith("/messages/")
  };
};
export function useActiveWaveManager() {
  const $ = _c(11);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    isApp
  } = useDeviceInfo();
  let t0;
  if ($[0] !== pathname || $[1] !== searchParams) {
    t0 = getActiveWaveIdFromUrl({
      pathname,
      searchParams
    });
    $[0] = pathname;
    $[1] = searchParams;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const waveFromLocation = t0;
  let t1;
  if ($[3] !== isApp) {
    t1 = (waveId, options) => {
      const isDirectMessage = options?.isDirectMessage ?? false;
      const serialNo = options?.serialNo ?? undefined;
      const divider = options?.divider;
      return waveId ? getWaveRoute({
        waveId,
        serialNo,
        extraParams: {
          divider: divider !== null && divider !== undefined ? String(divider) : undefined
        },
        isDirectMessage,
        isApp
      }) : getWaveHomeRoute({
        isDirectMessage,
        isApp
      });
    };
    $[3] = isApp;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const buildUrl = t1;
  const canUsePushState = _temp;
  let t2;
  if ($[5] !== buildUrl || $[6] !== waveFromLocation) {
    t2 = {
      initialState: waveFromLocation,
      buildUrl,
      parseUrl: getWaveFromWindow,
      canUsePushState
    };
    $[5] = buildUrl;
    $[6] = waveFromLocation;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const {
    state: activeWaveId,
    navigate: setActiveWave
  } = useClientNavigation(t2);
  let t3;
  if ($[8] !== activeWaveId || $[9] !== setActiveWave) {
    t3 = {
      activeWaveId,
      setActiveWave
    };
    $[8] = activeWaveId;
    $[9] = setActiveWave;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp(_targetUrl, options_0) {
  const {
    isOnWaves,
    isOnMessages
  } = getRouteContext();
  const isDirectMessage_0 = options_0?.isDirectMessage ?? false;
  return !isDirectMessage_0 && isOnWaves || isDirectMessage_0 && isOnMessages;
}